import { ClientDashboardAccess } from "src/pages/client-management/types/client.types";

// url based access
const isClientUrl = (): boolean => {
  return window.location.href.includes('/client');
};

const isOrgUrl = (): boolean => {
  return !window.location.href.includes('/client');
};

// client access control

const hasSurveyCreateAccess = (clientPermissions?: { permissions?: ClientDashboardAccess[] }): boolean => {
  if (!clientPermissions?.permissions) return false;
  return clientPermissions.permissions.some((permission) => permission.page === 'surveys' && permission.tab === 'surveys' && permission.permission === 'create_survey');
};

const hasSurveyAIPanelAccess = (clientPermissions?: { permissions?: ClientDashboardAccess[] }): boolean => {
  if (!clientPermissions?.permissions) return false;
  return clientPermissions.permissions.some((permission) => permission.page === 'surveys' && permission.tab === 'surveys' && permission.permission === 'ai_panel');
};

// fine grained access control
const isSuperAdmin = (userPermissions?: { groups?: string[] }): boolean => {
  if (!userPermissions?.groups) return false;
  return userPermissions.groups.includes('super_admin');
};

const isClientUser = (userPermissions?: { groups?: string[] }): boolean => {
  if (!userPermissions?.groups) return false;
  return userPermissions.groups.includes('client_user') || userPermissions.groups.includes('client_admin');
};

const isClientAdmin = (userPermissions?: { groups?: string[] }): boolean => {
  if (!userPermissions?.groups) return false;
  return userPermissions.groups.includes('client_admin');
};

const isOrgUser = (userPermissions?: { groups?: string[] }): boolean => {
  if (!userPermissions?.groups) return false;
  return userPermissions.groups.includes('org_user');
};

const isB2BUser = (userPermissions?: { groups?: string[] }): boolean => {
  if (!userPermissions?.groups) return false;
  return userPermissions.groups.includes('b2b_user');
};

const isOrgAdmin = (userPermissions?: { groups?: string[] }): boolean => {
  if (!userPermissions?.groups) return false;
  return userPermissions.groups.includes('org_admin');
};


// overall user membership
const isOrgMember = (userPermissions?: { groups?: string[] }): boolean => {
  if (!userPermissions?.groups) return false;
  return userPermissions.groups.includes('org_user') || userPermissions.groups.includes('org_admin');
};

const isClientMember = (userPermissions?: { groups?: string[] }): boolean => {
  if (!userPermissions?.groups) return false;
  return userPermissions.groups.includes('client_user') || userPermissions.groups.includes('client_admin');
};

export { isSuperAdmin, isClientUser, isClientAdmin, isOrgUser, isOrgAdmin, isOrgMember, isClientMember, isClientUrl, isOrgUrl, isB2BUser, hasSurveyCreateAccess, hasSurveyAIPanelAccess };